"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetAFreeEstimate() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section ref={ref} className="bg-background py-16 sm:py-24">
      <div className={`container mx-auto px-6 text-center transition-all duration-[var(--duration-slow)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
        <h2 className="font-display text-3xl font-bold text-foreground sm:text-4xl lg:text-5xl">
          Get a Free Estimate
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-base text-muted sm:text-lg">
          Ready to get started? Contact us today for a free, no-obligation estimate on your plumbing or mechanical system needs.
        </p>
        <div className="mt-8">
          <Button asChild size="lg" className="bg-accent text-foreground hover:bg-accent-hover rounded-xl shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:-translate-y-0.5 hover:shadow-medium active:translate-y-0 active:bg-accent-active">
            <Link to="/ContactPage">Request Your Estimate</Link>
          </Button>
        </div>
      </div>
    </section>;
}